import React from 'react';
import Size from '../../../../models/constants/size';
import SVG_COMPONENTS from './SvgComponents';
import styles from './Icon.styles';
import { IconRotate } from './types';
import SvgIcons from '../../../../models/constants/svgIcons';

export interface IconProps {
  // title?: string;
  size?: Exclude<Size, Size.XLARGE>;
  rotate?: IconRotate | false;
  iconName?: string;
  className?: string;
  onMouseDown?: () => void;
  onMouseUp?: () => void;
}

const Icon: React.FC<
  React.PropsWithChildren<React.PropsWithChildren<IconProps>>
> = ({
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  size = Size.MEDIUM,
  iconName = SvgIcons.HEART,
  className,
  rotate,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onMouseDown = () => {},
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onMouseUp = () => {},
}) => {
  const RenderIcon = SVG_COMPONENTS[iconName as SvgIcons];

  return (
    <span
      className="inline-block align-middle"
      style={styles.rotate(rotate)}
      onMouseDown={onMouseDown}
      onMouseUp={onMouseUp}
    >
      {RenderIcon ? <RenderIcon className={className} /> : null}
    </span>
  );
};

export default Icon;
